(function () {
  if (window.NFVariantFilters) return;

  const inputSelector = '[data-nf-filter-input]';
  const cardSelector = '#product-grid > .grid__item[data-nf-brand]';

  function selectedValues(kind) {
    return new Set(
      [...document.querySelectorAll(`${inputSelector}[data-nf-filter-kind="${kind}"]:checked`)].map(
        (input) => input.value,
      ),
    );
  }

  function cardValues(card, kind) {
    const raw = card.dataset[`nf${kind[0].toUpperCase()}${kind.slice(1)}`] || '';
    return new Set(raw.split('|').filter(Boolean));
  }

  function matchesGroup(card, kind, selected) {
    if (selected.size === 0) return true;
    const values = cardValues(card, kind);
    return [...selected].some((value) => values.has(value));
  }

  function updateSelectedBadges() {
    ['brand', 'size', 'color'].forEach((kind) => {
      const count = selectedValues(kind).size;
      document.querySelectorAll(`[data-nf-selected-count="${kind}"]`).forEach((badge) => {
        // Usa a classe .hidden do tema, igual ao contador das facetas nativas.
        // O atributo `hidden` nao servia: qualquer `display` do CSS o anula, e era
        // por isso que o contador aparecia como uma bolinha mesmo com zero selecionado.
        badge.textContent = `(${count})`;
        badge.classList.toggle('hidden', count === 0);
      });
    });
  }

  function updateCount(visible, active) {
    document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach((node) => {
      if (!node.dataset.nfOriginalCount) node.dataset.nfOriginalCount = node.innerHTML;
      const nextCount = active
        ? `${visible} ${visible === 1 ? 'produto' : 'produtos'}`
        : node.dataset.nfOriginalCount;

      if (node.innerHTML !== nextCount) node.innerHTML = nextCount;
    });
  }

  function updateEmptyState(grid, visible, active) {
    const container = grid.closest('.collection');
    let empty = container?.querySelector('.nf-variant-filters__no-results');
    if (active && visible === 0) {
      if (!empty) {
        empty = document.createElement('p');
        empty.className = 'nf-variant-filters__no-results';
        empty.setAttribute('role', 'status');
        empty.textContent = 'Nenhum produto corresponde às variações selecionadas.';
        grid.after(empty);
      }
    } else {
      empty?.remove();
    }
  }

  function applyFilters() {
    const cards = [...document.querySelectorAll(cardSelector)];
    if (!cards.length) return;

    const selections = {
      brand: selectedValues('brand'),
      size: selectedValues('size'),
      color: selectedValues('color'),
    };
    const active = Object.values(selections).some((set) => set.size > 0);
    let visible = 0;

    cards.forEach((card) => {
      const matches = Object.entries(selections).every(([kind, selected]) => matchesGroup(card, kind, selected));
      card.classList.toggle('nf-product-filter-hidden', !matches);
      card.setAttribute('aria-hidden', matches ? 'false' : 'true');
      if (matches) visible += 1;
    });

    document.querySelectorAll('[data-nf-filter-clear]').forEach((button) => {
      button.hidden = !active;
    });
    updateSelectedBadges();
    updateCount(visible, active);
    updateEmptyState(document.querySelector('#product-grid'), visible, active);
  }

  function syncInput(source) {
    document
      .querySelectorAll(
        `${inputSelector}[data-nf-filter-kind="${source.dataset.nfFilterKind}"][value="${CSS.escape(source.value)}"]`,
      )
      .forEach((input) => {
        input.checked = source.checked;
      });
  }

  // Estes filtros vivem DENTRO do <form> de facets do Dawn (drawer "Filtrar e
  // organizar" e coluna do desktop). O Dawn escuta 'input' no proprio form
  // (facets.js) e refaz a busca a cada evento que borbulha ate la. Os checkboxes
  // daqui nao tem atributo name e nao pertencem aquele form: deixar o evento
  // subir faria o Dawn re-renderizar a secao e descartar a selecao. Barramos so
  // o 'input'; o 'change' continua subindo, que e o evento escutado abaixo.
  document.addEventListener(
    'input',
    (event) => {
      if (event.target.closest?.(inputSelector)) event.stopPropagation();
    },
    true,
  );

  document.addEventListener('change', (event) => {
    const input = event.target.closest(inputSelector);
    if (!input) return;
    syncInput(input);
    applyFilters();
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-nf-filter-clear]')) return;
    document.querySelectorAll(inputSelector).forEach((input) => {
      input.checked = false;
    });
    applyFilters();
  });

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => [...mutation.addedNodes].some((node) => node.nodeType === 1))) {
      window.requestAnimationFrame(applyFilters);
    }
  });

  function init() {
    const container = document.querySelector('#ProductGridContainer');
    if (container) observer.observe(container, { childList: true, subtree: true });
    applyFilters();
  }

  window.NFVariantFilters = { apply: applyFilters };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
